module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/collapse_expand_icon.png?305214ad721d9b1d53be5e1175928328";